export default __webpack_public_path__ + "static/media/listing-page.03d5aff5.png";